import * as Yup from "yup";
export const atLeastOneField = "At least one option must be selected";
export const generalErrorMessage = "Field is required";
export const validationSchemaGeneralInfo = Yup.object({
    brand_info_general_info_client_name: Yup.string()
        .required("Client name is required")
        .min(1, "Client name is required"),
    brand_info_general_info_brand_name: Yup.string()
        .required("Brand name is required")
        .min(1, "Brand name is required"),
    brand_info_general_info_responsible_for_app_publish: Yup.array(Yup.string())
        .required("At least one field must be selected")
        .min(1, "At least one field must be selected"),
    brand_info_general_info_card_network: Yup.array(Yup.string())
        .required("At least one Card Network must be selected")
        .min(1, "At least one Card Network must be selected"),
    brand_info_general_info_card_network_other: Yup.string().when(["brand_info_general_info_card_network"], {
        is: (brand_info_general_info_card_network) =>
            brand_info_general_info_card_network && brand_info_general_info_card_network.includes("Other"),
        then: () =>
            Yup.string()
                .required(generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    brand_info_general_info_brand_color: Yup.string()
        .required("Brand color is required")
        .min(1, "Brand color is required"),
    brand_info_general_info_brand_color_custom_primary: Yup.string().when("brand_info_general_info_brand_color", {
        is: (brand_info_general_info_brand_color) => brand_info_general_info_brand_color === "Custom color scheme",
        then: () => Yup.string().required(generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    brand_info_general_info_brand_color_custom_secondary: Yup.string().when("brand_info_general_info_brand_color", {
        is: (brand_info_general_info_brand_color) => brand_info_general_info_brand_color === "Custom color scheme",
        then: () => Yup.string().required(generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    brand_info_general_info_brand_color_custom_neutral: Yup.string().when("brand_info_general_info_brand_color", {
        is: (brand_info_general_info_brand_color) => brand_info_general_info_brand_color === "Custom color scheme",
        then: () => Yup.string().required(generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    brand_info_general_info_brand_logo_file: Yup.string().when("brand_info_general_info_brand_color", {
        is: (brand_info_general_info_brand_color) => brand_info_general_info_brand_color === "Brand color scheme",
        then: () => Yup.string().required(generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    brand_info_general_info_url_type_enrollment_screen: Yup.string()
        .required("Website URL is required")
        .min(1, "Website URL is required"),
    brand_info_general_info_url_type_enrollment_screen_custom: Yup.string().when("brand_info_general_info_url_type_enrollment_screen", {
        is: (brand_info_general_info_url_type_enrollment_screen) => brand_info_general_info_url_type_enrollment_screen === "Use custom URL",
        then: () => Yup.string().required(generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    brand_info_general_info_language: Yup.array(Yup.string())
        .required("At least one Language must be selected")
        .min(1, "At least one Language must be selected"),
    brand_info_general_info_language_other: Yup.string().when(["brand_info_general_info_language"], {
        is: (brand_info_general_info_language) =>
            brand_info_general_info_language && brand_info_general_info_language.includes("Other"),
        then: () =>
            Yup.array()
                .required(generalErrorMessage).min(1, "At least one value should be selected"),
        otherwise: () => Yup.array().optional(),
    }),
    brand_info_general_info_target_launch_date: Yup.string()
        .required("Launch Date is required")
        .min(1, "Launch Date is required"),
    brand_info_general_info_target_launch_date_mobile_app: Yup.string().optional(),
    brand_info_general_info_target_launch_date_web_app: Yup.string().optional(),
});
export const validationSchemaWeb = Yup.object({
    brand_info_web_app_add_program_logo: Yup.string().optional(),
    brand_info_web_app_program_logo_file: Yup.string().when("brand_info_web_app_add_program_logo", {
        is: (brand_info_web_app_add_program_logo) => brand_info_web_app_add_program_logo === "Yes",
        then: () => Yup.string().optional(),
        otherwise: () => Yup.string().optional(),
    }),
    brand_info_web_app_add_link_to_public_pages: Yup.string().optional(),
    brand_info_web_app_links_to_public_pages: Yup.string().when("brand_info_web_app_add_link_to_public_pages", {
        is: (brand_info_web_app_add_link_to_public_pages) => brand_info_web_app_add_link_to_public_pages === "Yes",
        then: () => Yup.string().optional(),
        otherwise: () => Yup.string().optional(),
    }),
    brand_info_web_app_public_pages: Yup.array().when("brand_info_web_app_add_link_to_public_pages", {
        is: (brand_info_web_app_add_link_to_public_pages) => brand_info_web_app_add_link_to_public_pages === "Yes",
        then: () =>
            Yup.array()
                .of(
                    Yup.object({
                        page_name: Yup.string()
                            .required(generalErrorMessage)
                            .min(1, generalErrorMessage),
                        page_link: Yup.string()
                            .required(generalErrorMessage)
                            .min(1, generalErrorMessage),
                    }),
                )
                .min(1, generalErrorMessage),
        otherwise: () => Yup.array().optional(),
    }),
    brand_info_web_app_add_link_to_self_service_enrollment: Yup.string().optional(),
    brand_info_web_app_add_card_activation_feature: Yup.string().optional(),
    brand_info_web_app_main_banner_file: Yup.string().optional(),
    brand_info_web_app_heading_and_text: Yup.string().optional(),
    brand_info_web_app_add_video_link: Yup.string().optional(),
    brand_info_web_app_video_url: Yup.string().when("brand_info_web_app_add_video_link", {
        is: (brand_info_web_app_add_video_link) => brand_info_web_app_add_video_link === "Yes",
        then: () => Yup.string().required("Field is required"),
        otherwise: () => Yup.string().optional(),
    }),
    brand_info_web_app_offer_card_products_for_enrollment: Yup.array(Yup.string())
        .required("At least one Manage must be selected")
        .min(1, "At least one Manage must be selected"),
    brand_info_web_app_content_for_card_products: Yup.string().optional(),
    brand_info_web_app_responsible_for_card_product_images: Yup.string()
        .required("card image option is required")
        .min(1, "card image option is required"),
    brand_info_web_app_card_product_images_file: Yup.array(Yup.string()).when("brand_info_web_app_responsible_for_card_product_images", {
        is: (brand_info_web_app_responsible_for_card_product_images) => brand_info_web_app_responsible_for_card_product_images === "Use client provided images / icons",
        then: () => Yup.array(Yup.string()).optional(),
        otherwise: () => Yup.array(Yup.string()).optional(),
    }),
    brand_info_web_app_content_for_card_products_features: Yup.string().optional(),
    brand_info_web_app_responsible_for_card_products_features_images: Yup.string()
        .required("card image feature option is required")
        .min(1, "card image feature option is required"),
    brand_info_web_app_card_products_features_images_file: Yup.array(Yup.string()).when("brand_info_web_app_responsible_for_card_products_features_images", {
        is: (brand_info_web_app_responsible_for_card_products_features_images) => brand_info_web_app_responsible_for_card_products_features_images === "Use client provided images / icons",
        then: () => Yup.array(Yup.string()).optional(),
        otherwise: () => Yup.array(Yup.string()).optional(),
    }),
    brand_info_web_info_section_vi_add_section_to_landing_page: Yup.string().optional(),
    brand_info_web_info_section_vi_icon_textual_content_images_file: Yup.array(Yup.string()).when("brand_info_web_info_section_vi_add_section_to_landing_page", {
        is: (brand_info_web_info_section_vi_add_section_to_landing_page) => brand_info_web_info_section_vi_add_section_to_landing_page === "Yes",
        then: () => Yup.array(Yup.string()).optional(),
        otherwise: () => Yup.array(Yup.string()).optional(),
    }),
    brand_info_web_info_add_image_of_mobile_app_section: Yup.string().optional(),
    brand_info_web_info_add_links_for_app: Yup.array(Yup.string()).when("brand_info_web_info_add_image_of_mobile_app_section", {
        is: (brand_info_web_info_add_image_of_mobile_app_section) => brand_info_web_info_add_image_of_mobile_app_section && brand_info_web_info_add_image_of_mobile_app_section === "Yes",
        then: () => Yup.array(Yup.string()).required("Add at least one link").min(1, "Add at least one link"),
        otherwise: () => Yup.array(Yup.string()).optional(),
    }),
    brand_info_web_info_mobile_app_images_file: Yup.array(Yup.string()).when("brand_info_web_info_add_image_of_mobile_app_section", {
        is: (brand_info_web_info_add_image_of_mobile_app_section) => brand_info_web_info_add_image_of_mobile_app_section && brand_info_web_info_add_image_of_mobile_app_section === "Yes",
        then: () => Yup.array(Yup.string()).optional(),
        otherwise: () => Yup.array(Yup.string()).optional(),
    }),

    brand_info_web_info_footer_public_pages_links: Yup.array(Yup.string())
        .required("Please specify at least on information")
        .min(1, "Please specify at least on information"),
    brand_info_web_info_footer_public_pages_content: Yup.string().optional(),
});
export const validationSchemaMob = Yup.object({
    brand_info_mob_app_icon_file: Yup.string().optional(),
    brand_info_mob_app_splash_screen_file: Yup.string().optional(),
    brand_info_mob_app_card_design_file: Yup.string().optional(),
    brand_info_mob_app_textual_content: Yup.string().optional(),
    brand_info_mob_app_art_background_image_file: Yup.string().optional(),
    brand_info_mob_app_additional_textual_content_file: Yup.string().optional(),
    brand_info_mob_app_sign_up_option: Yup.string().optional(),
    brand_info_mob_app_nav_color_scheme: Yup.string().optional(),
    brand_info_mob_app_nav_color_scheme_field: Yup.string().when("brand_info_mob_app_nav_color_scheme", {
        is: (brand_info_mob_app_nav_color_scheme) => brand_info_mob_app_nav_color_scheme === "Custom color scheme",
        then: () => Yup.string().required("Field is required"),
        otherwise: () => Yup.string().optional(),
    }),
    brand_info_mob_app_nav_color_scheme_logo: Yup.string().optional(),
    brand_info_mob_app_login_color_scheme_code: Yup.array().of(Yup.string().required("Color code is required")).optional(),
    brand_info_mob_app_login_background_file: Yup.string().optional(),
    brand_info_mob_app_public_menus_icons_type: Yup.string().optional(),
    brand_info_mob_app_public_menus_custom: Yup.array().when("brand_info_mob_app_public_menus_icons_type", {
        is: (brand_info_mob_app_public_menus_icons_type) => brand_info_mob_app_public_menus_icons_type === "Custom color scheme",
        then: () =>
            Yup.array().of(
                Yup.object().shape({
                    feature: Yup.string().optional(),
                    enabled: Yup.boolean(),
                    deleteable: Yup.boolean(),
                    alternativeMethod: Yup.string().optional(),
                })
            ).nullable(),
        otherwise: () => Yup.array().optional(),
    }),

    brand_info_mob_app_ios_icon_file: Yup.string().optional(),
    brand_info_mob_app_ios_app_name: Yup.string().required("Field is required").min(1, "Field is required"),
    brand_info_mob_app_ios_description_for_app_store: Yup.string().optional(),
    brand_info_mob_app_ios_keywords: Yup.string().optional(),
    brand_info_mob_app_ios_support_url: Yup.string().optional(),
    brand_info_mob_app_ios_module_features_file: Yup.array(Yup.string()).optional(),
    brand_info_mob_app_android_icon_file: Yup.string().optional(),
    brand_info_mob_app_android_app_name: Yup.string().required("Field is required").min(1, "Field is required"),
    brand_info_mob_app_android_description_for_app_store: Yup.string().optional(),
    brand_info_mob_app_android_keywords: Yup.string().optional(),
    brand_info_mob_app_android_support_url: Yup.string().optional(),
    brand_info_mob_app_android_module_features_file: Yup.array(Yup.string()).optional(),
});
export const getValidationSchemaMobileReal = (appSelectionForProgram) => {
    const isMobileSelected = appSelectionForProgram.includes("Android App");
    const isIosSelected = appSelectionForProgram.includes("iOS App");
    const baseFields = {
        brand_info_mob_app_icon_file: Yup.string().optional(),
        brand_info_mob_app_splash_screen_file: Yup.string().optional(),
        brand_info_mob_app_card_design_file: Yup.string().optional(),
        brand_info_mob_app_textual_content: Yup.string().optional(),
        brand_info_mob_app_art_background_image_file: Yup.string().optional(),
        brand_info_mob_app_additional_textual_content_file: Yup.string().optional(),
        brand_info_mob_app_sign_up_option: Yup.string().optional(),
        brand_info_mob_app_nav_color_scheme: Yup.string().optional(),
        brand_info_mob_app_nav_color_scheme_field: Yup.string().when("brand_info_mob_app_nav_color_scheme", {
            is: (brand_info_mob_app_nav_color_scheme) => brand_info_mob_app_nav_color_scheme === "Custom color scheme",
            then: () => Yup.string().required("Custom color scheme field is required"),
            otherwise: () => Yup.string().nullable(),
        }),
        brand_info_mob_app_nav_color_scheme_logo: Yup.string().required("Navigation logo is required"),
        brand_info_mob_app_login_color_scheme_code: Yup.array()
            .of(Yup.string().required("Color code is required"))
            .min(1, "At least one color code is required"),
        brand_info_mob_app_login_background_file: Yup.string().optional(),
        brand_info_mob_app_public_menus_icons_type: Yup.string().required("Public menus icons type is required"),
        brand_info_mob_app_public_menus_custom: Yup.array().when("brand_info_mob_app_public_menus_icons_type", {
            is: (brand_info_mob_app_public_menus_icons_type) => brand_info_mob_app_public_menus_icons_type === "Custom Menus & Icons",
            then: () =>
                Yup.array().of(
                    Yup.object().shape({
                        feature: Yup.string().optional(),
                        enabled: Yup.boolean(),
                        deleteable: Yup.boolean(),
                        alternativeMethod: Yup.string().optional(),
                    })
                ).nullable(),
            otherwise: () => Yup.array().nullable(),
        }),
    };

    if (isMobileSelected) {
        baseFields.brand_info_mob_app_android_icon_file = Yup.string().optional();
        baseFields.brand_info_mob_app_android_app_name = Yup.string()
            .required("Android app name is required")
            .min(1, "Android app name is required");
        baseFields.brand_info_mob_app_android_description_for_app_store = Yup.string().required(
            "Android app description is required"
        );
        baseFields.brand_info_mob_app_android_keywords = Yup.string().required("Android keywords are required");
        baseFields.brand_info_mob_app_android_support_url = Yup.string()
            .required("Android support URL is required");
        baseFields.brand_info_mob_app_android_module_features_file = Yup.array(Yup.string()).optional();
    }

    if (isIosSelected) {
        baseFields.brand_info_mob_app_ios_icon_file = Yup.string().optional();
        baseFields.brand_info_mob_app_ios_app_name = Yup.string()
            .required("iOS app name is required")
            .min(1, "iOS app name is required");
        baseFields.brand_info_mob_app_ios_description_for_app_store = Yup.string().required(
            "iOS app description is required"
        );
        baseFields.brand_info_mob_app_ios_keywords = Yup.string().required("iOS keywords are required");
        baseFields.brand_info_mob_app_ios_support_url = Yup.string()
            .required("iOS support URL is required");
        baseFields.brand_info_mob_app_ios_module_features_file = Yup.array(Yup.string()).optional();
    }

    return Yup.object().shape(baseFields);
};
export const getValidationSchemaMobile = (appSelectionForProgram) => {
    const isMobileSelected = appSelectionForProgram.includes("Android App");
    const isIosSelected = appSelectionForProgram.includes("iOS App");
    const baseFields = {
        brand_info_mob_app_icon_file: Yup.string().optional(),
        brand_info_mob_app_splash_screen_file: Yup.string().optional(),
        brand_info_mob_app_card_design_file: Yup.string().optional(),
        brand_info_mob_app_textual_content: Yup.string().optional(),
        brand_info_mob_app_art_background_image_file: Yup.string().optional(),
        brand_info_mob_app_additional_textual_content_file: Yup.string().optional(),
        brand_info_mob_app_sign_up_option: Yup.string().optional(),
        brand_info_mob_app_nav_color_scheme: Yup.string().optional(),
        brand_info_mob_app_nav_color_scheme_field: Yup.string().when("brand_info_mob_app_nav_color_scheme", {
            is: (brand_info_mob_app_nav_color_scheme) => brand_info_mob_app_nav_color_scheme === "Custom color scheme",
            then: () => Yup.string().required("Field is required"),
            otherwise: () => Yup.string().optional(),
        }),
        brand_info_mob_app_nav_color_scheme_logo: Yup.string().optional(),
        brand_info_mob_app_login_color_scheme_code: Yup.array()
            .of(Yup.string().required("Color code is required"))
            .min(1, "At least one color code is required"),
        brand_info_mob_app_login_background_file: Yup.string().optional(),
        brand_info_mob_app_public_menus_icons_type: Yup.string().optional(),
        brand_info_mob_app_public_menus_custom: Yup.array().when("brand_info_mob_app_public_menus_icons_type", {
            is: (brand_info_mob_app_public_menus_icons_type) => brand_info_mob_app_public_menus_icons_type === "Custom Menus & Icons",
            then: () =>
                Yup.array().of(
                    Yup.object().shape({
                        feature: Yup.string().optional(),
                        enabled: Yup.boolean(),
                        deleteable: Yup.boolean(),
                        alternativeMethod: Yup.string().optional(),
                    })
                ).nullable(),
            otherwise: () => Yup.array().optional(),
        }),

    }
    if (isMobileSelected) {
        baseFields.brand_info_mob_app_android_icon_file = Yup.string().optional();
        baseFields.brand_info_mob_app_android_app_name = Yup.string().required("Field is required").min(1, "Field is required");
        baseFields.brand_info_mob_app_android_description_for_app_store = Yup.string().optional();
        baseFields.brand_info_mob_app_android_keywords = Yup.string().optional();
        baseFields.brand_info_mob_app_android_support_url = Yup.string().optional();
        baseFields.brand_info_mob_app_android_module_features_file = Yup.array(Yup.string()).optional();
    }
    if (isIosSelected) {
        baseFields.brand_info_mob_app_ios_icon_file = Yup.string().optional();
        baseFields.brand_info_mob_app_ios_app_name = Yup.string().required("Field is required").min(1, "Field is required");
        baseFields.brand_info_mob_app_ios_description_for_app_store = Yup.string().optional();
        baseFields.brand_info_mob_app_ios_keywords = Yup.string().optional();
        baseFields.brand_info_mob_app_ios_support_url = Yup.string().optional();
        baseFields.brand_info_mob_app_ios_module_features_file = Yup.array(Yup.string()).optional();
    }
    return Yup.object(baseFields);
}
export const getValidationSchemaCommon = (type) => {
    let schema = {
        brand_info_common_brand_contact_us_feature_type: Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        brand_info_common_brand_contact_us_i2c_standard_email: Yup.string().when("brand_info_common_brand_contact_us_feature_type", {
            is: (brand_info_common_brand_contact_us_feature_type) => brand_info_common_brand_contact_us_feature_type === "Use i2c Standard Feature",
            then: () => Yup.string().required(generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        }),
        brand_info_common_brand_contact_us_i2c_standard_customer_call_phone: Yup.string().when("brand_info_common_brand_contact_us_feature_type", {
            is: (brand_info_common_brand_contact_us_feature_type) => brand_info_common_brand_contact_us_feature_type === "Use i2c Standard Feature",
            then: () => Yup.string().required(generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        }),
        brand_info_common_brand_contact_us_i2c_standard_customer_call_phone_country: Yup.string().when("brand_info_common_brand_contact_us_feature_type", {
            is: (brand_info_common_brand_contact_us_feature_type) => brand_info_common_brand_contact_us_feature_type === "Use i2c Standard Feature",
            then: () => Yup.string().required(generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        }),
        brand_info_common_brand_contact_us_i2c_standard_cardholder_enrollment_phone: Yup.string().when("brand_info_common_brand_contact_us_feature_type", {
            is: (brand_info_common_brand_contact_us_feature_type) => brand_info_common_brand_contact_us_feature_type === "Use i2c Standard Feature",
            then: () => Yup.string().required(generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        }),
        brand_info_common_brand_contact_us_i2c_standard_cardholder_enrollment_phone_country: Yup.string().when("brand_info_common_brand_contact_us_feature_type", {
            is: (brand_info_common_brand_contact_us_feature_type) => brand_info_common_brand_contact_us_feature_type === "Use i2c Standard Feature",
            then: () => Yup.string().required(generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        }),
        brand_info_common_brand_contact_us_i2c_standard_working_hours: Yup.string().when("brand_info_common_brand_contact_us_feature_type", {
            is: (brand_info_common_brand_contact_us_feature_type) => brand_info_common_brand_contact_us_feature_type === "Use i2c Standard Feature",
            then: () => Yup.string().required(generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        }),
        brand_info_common_brand_contact_us_i2c_standard_head_office_address: Yup.string().when("brand_info_common_brand_contact_us_feature_type", {
            is: (brand_info_common_brand_contact_us_feature_type) => brand_info_common_brand_contact_us_feature_type === "Use i2c Standard Feature",
            then: () => Yup.string().required(generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        }),
        brand_info_common_brand_contact_us_i2c_standard_postal_address: Yup.string().when("brand_info_common_brand_contact_us_feature_type", {
            is: (brand_info_common_brand_contact_us_feature_type) => brand_info_common_brand_contact_us_feature_type === "Use i2c Standard Feature",
            then: () => Yup.string().required(generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        }),
        brand_info_common_brand_contact_us_i2c_standard_facebook_link: Yup.string().when("brand_info_common_brand_contact_us_feature_type", {
            is: (brand_info_common_brand_contact_us_feature_type) => brand_info_common_brand_contact_us_feature_type === "Use i2c Standard Feature",
            then: () => Yup.string().required(generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        }),
        brand_info_common_brand_contact_us_i2c_standard_instagram_link: Yup.string().when("brand_info_common_brand_contact_us_feature_type", {
            is: (brand_info_common_brand_contact_us_feature_type) => brand_info_common_brand_contact_us_feature_type === "Use i2c Standard Feature",
            then: () => Yup.string().required(generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        }),
        brand_info_common_brand_contact_us_i2c_standard_twitter_link: Yup.string().when("brand_info_common_brand_contact_us_feature_type", {
            is: (brand_info_common_brand_contact_us_feature_type) => brand_info_common_brand_contact_us_feature_type === "Use i2c Standard Feature",
            then: () => Yup.string().required(generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        }),
        brand_info_common_brand_contact_us_i2c_standard_youtube_link: Yup.string().when("brand_info_common_brand_contact_us_feature_type", {
            is: (brand_info_common_brand_contact_us_feature_type) => brand_info_common_brand_contact_us_feature_type === "Use i2c Standard Feature",
            then: () => Yup.string().required(generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        }),
        brand_info_common_brand_contact_us_i2c_standard_linkedin_link: Yup.string().when("brand_info_common_brand_contact_us_feature_type", {
            is: (brand_info_common_brand_contact_us_feature_type) => brand_info_common_brand_contact_us_feature_type === "Use i2c Standard Feature",
            then: () => Yup.string().required(generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        }),
        brand_info_common_brand_contact_us_custom: Yup.array().when("brand_info_common_brand_contact_us_feature_type", {
            is: (brand_info_common_brand_contact_us_feature_type) => brand_info_common_brand_contact_us_feature_type === "Use External URL",
            then: () =>
                Yup.array()
                    .of(
                        Yup.object({
                            page_name: Yup.string()
                                .required(generalErrorMessage)
                                .min(1, generalErrorMessage),
                            page_link: Yup.string()
                                .required(generalErrorMessage)
                                .min(1, generalErrorMessage),
                        }),
                    )
                    .min(1, generalErrorMessage),
            otherwise: () => Yup.array().optional(),
        }),
        brand_info_common_brand_faqs_type: Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        brand_info_common_brand_faqs_content_file: Yup.array(Yup.string()).when("brand_info_common_brand_faqs_type", {
            is: (brand_info_common_brand_faqs_type) => brand_info_common_brand_faqs_type === "Use Customized Content",
            then: () => Yup.array(Yup.string()).optional(),
            otherwise: () => Yup.array(Yup.string()).optional(),
        }),
        brand_info_common_brand_faqs_external_link: Yup.string().when("brand_info_common_brand_faqs_type", {
            is: (brand_info_common_brand_faqs_type) => brand_info_common_brand_faqs_type === "Use External URL",
            then: () => Yup.string().required(generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        }),
        brand_info_common_brand_terms_and_condition_type: Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        brand_info_common_brand_terms_and_condition_content_file: Yup.array(Yup.string()).when("brand_info_common_brand_terms_and_condition_type", {
            is: (brand_info_common_brand_terms_and_condition_type) => brand_info_common_brand_terms_and_condition_type === "Use Customized Content",
            then: () => Yup.array(Yup.string()).optional(),
            otherwise: () => Yup.array(Yup.string()).optional(),
        }),
        brand_info_common_brand_terms_and_condition_content_link: Yup.string().when("brand_info_common_brand_terms_and_condition_type", {
            is: (brand_info_common_brand_terms_and_condition_type) => brand_info_common_brand_terms_and_condition_type === "Use External URL",
            then: () => Yup.string().required(generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        }),
        brand_info_common_brand_privacy_policy_type: Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        brand_info_common_brand_privacy_policy_content_file: Yup.array(Yup.string()).when("brand_info_common_brand_privacy_policy_type", {
            is: (brand_info_common_brand_privacy_policy_type) => brand_info_common_brand_privacy_policy_type === "Use Customized Content",
            then: () => Yup.array(Yup.string()).optional(),
            otherwise: () => Yup.array(Yup.string()).optional(),
        }),
        brand_info_common_brand_privacy_policy_content_link: Yup.string().when("brand_info_common_brand_privacy_policy_type", {
            is: (brand_info_common_brand_privacy_policy_type) => brand_info_common_brand_privacy_policy_type === "Use External URL",
            then: () => Yup.string().required(generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        }),

        brand_info_common_brand_security_awareness_type: Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        brand_info_common_brand_security_awareness_content_file: Yup.array(Yup.string()).when("brand_info_common_brand_security_awareness_type", {
            is: (brand_info_common_brand_security_awareness_type) => brand_info_common_brand_security_awareness_type === "Use Customized Content",
            then: () => Yup.array(Yup.string()).optional(),
            otherwise: () => Yup.array(Yup.string()).optional(),
        }),
        brand_info_common_brand_security_awareness_content_link: Yup.string().when("brand_info_common_brand_security_awareness_type", {
            is: (brand_info_common_brand_security_awareness_type) => brand_info_common_brand_security_awareness_type === "Use External URL",
            then: () => Yup.string().required(generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        }),

        brand_info_common_brand_feature: Yup.array()
            .of(
                Yup.object({
                    name: Yup.string()
                        .required(generalErrorMessage),
                    description: Yup.string()
                        .required(generalErrorMessage),
                    attachment_file: Yup.string()
                        .nullable(),
                })
            )
            .min(1, generalErrorMessage),
    }

    if (type === 'prepaid') {
        schema = {
            ...schema,
            brand_info_common_brand_atm_locator: Yup.string().required(generalErrorMessage),
            brand_info_common_brand_atm_locator_content_file: Yup.string().optional(),
        };
    }

    return Yup.object(schema);
}

export const getFieldsCommon = (type) => {
    const fieldsCommon = [
        "brand_info_common_brand_contact_us_feature_type",
        "brand_info_common_brand_contact_us_i2c_standard_email",
        "brand_info_common_brand_contact_us_i2c_standard_customer_call_phone",
        "brand_info_common_brand_contact_us_i2c_standard_customer_call_phone_country",
        "brand_info_common_brand_contact_us_i2c_standard_cardholder_enrollment_phone",
        "brand_info_common_brand_contact_us_i2c_standard_cardholder_enrollment_phone_country",
        "brand_info_common_brand_contact_us_i2c_standard_working_hours",
        "brand_info_common_brand_contact_us_i2c_standard_head_office_address",
        "brand_info_common_brand_contact_us_i2c_standard_postal_address",
        "brand_info_common_brand_contact_us_i2c_standard_facebook_link",
        "brand_info_common_brand_contact_us_i2c_standard_instagram_link",
        "brand_info_common_brand_contact_us_i2c_standard_twitter_link",
        "brand_info_common_brand_contact_us_i2c_standard_youtube_link",
        "brand_info_common_brand_contact_us_i2c_standard_linkedin_link",
        "brand_info_common_brand_contact_us_custom",
        "brand_info_common_brand_faqs_type",
        "brand_info_common_brand_faqs_content_file",
        "brand_info_common_brand_faqs_external_link",
        "brand_info_common_brand_terms_and_condition_type",
        "brand_info_common_brand_terms_and_condition_content_file",
        "brand_info_common_brand_terms_and_condition_content_link",
        "brand_info_common_brand_privacy_policy_type",
        "brand_info_common_brand_privacy_policy_content_file",
        "brand_info_common_brand_privacy_policy_content_link",
        "brand_info_common_brand_security_awareness_type",
        "brand_info_common_brand_security_awareness_content_file",
        "brand_info_common_brand_security_awareness_content_link",
        "brand_info_common_brand_feature",
        // "brand_info_common_brand_atm_locator",
        // "brand_info_common_brand_atm_locator_content_file",
    ];
    if (type === 'prepaid') {
        fieldsCommon.push(
            "brand_info_common_brand_atm_locator",
            "brand_info_common_brand_atm_locator_content_file"
        );
    }

    return fieldsCommon;
}
export const fieldsMob = [
    "brand_info_mob_app_icon_file",
    "brand_info_mob_app_splash_screen_file",
    "brand_info_mob_app_card_design_file",
    "brand_info_mob_app_card_design_file",
    "brand_info_mob_app_textual_content",
    "brand_info_mob_app_art_background_image_file",
    "brand_info_mob_app_additional_textual_content_file",
    "brand_info_mob_app_sign_up_option",
    "brand_info_mob_app_nav_color_scheme",
    "brand_info_mob_app_nav_color_scheme_field",
    "brand_info_mob_app_nav_color_scheme_logo",
    "brand_info_mob_app_login_background_file",
    "brand_info_mob_app_public_menus_icons_type",

    "brand_info_mob_app_ios_icon_file",
    "brand_info_mob_app_ios_app_name",
    "brand_info_mob_app_ios_description_for_app_store",
    "brand_info_mob_app_ios_keywords",
    "brand_info_mob_app_ios_support_url",
    "brand_info_mob_app_ios_module_features_file",
    "brand_info_mob_app_android_icon_file",
    "brand_info_mob_app_android_app_name",
    "brand_info_mob_app_android_description_for_app_store",
    "brand_info_mob_app_android_keywords",
    "brand_info_mob_app_android_support_url",
    "brand_info_mob_app_android_module_features_file",
    "brand_info_mob_app_public_menus_custom"
];


